import EventSubmission from './EventSubmission';

export default EventSubmission;
